const EMPTY = Symbol('lazy_empty_value')

export function lazy(target: any, propertyKey: string, descriptor?: PropertyDescriptor) {
    if (!descriptor || descriptor.get === undefined) {
        throw `@lazy ${propertyKey} must be a getter`
    }

    if (descriptor.set) {
        throw `@lazy ${propertyKey} must not have an associated setter`
    }

    const lazyKey = `_lazy_${propertyKey}`
    const initializer = descriptor.get

    Object.defineProperty(target, lazyKey, {
        enumerable: false,
        configurable: false,
        writable: true,
        value: EMPTY,
    })

    descriptor.get = function (this: any) {
        if (this[lazyKey] === EMPTY) {
            this[lazyKey] = initializer.call(this)
        }

        return this[lazyKey]
    }
}
